import { render, staticRenderFns } from "./SalesRegistrationDialog.vue?vue&type=template&id=51e6b06c&scoped=true&"
import script from "./SalesRegistrationDialog.vue?vue&type=script&lang=js&"
export * from "./SalesRegistrationDialog.vue?vue&type=script&lang=js&"
import style0 from "./SalesRegistrationDialog.vue?vue&type=style&index=0&id=51e6b06c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e6b06c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VRow})
